import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import * as _ from 'lodash'
import { Switch } from '@material-ui/core'

import styles from './styles'
import companySettings from '../../mockdata'

const useStyles = makeStyles(styles)

const Notifications: React.FunctionComponent<any> = () => {
	const classes = useStyles()
	const { notifications } = companySettings
	const [notificationsList, setState] = React.useState(notifications)

	const handleChange = (name: any) => (event: any) => {
		const newNotificationList = _.chain(notificationsList)
			.map(elem => ({
				...elem,
				checked:
					elem.id === name.id ? event.target.checked : elem.checked,
			}))
			.value()
		setState(newNotificationList)
	}
	return (
		<Grid
			className={classes.companyNotificationsRoot}
			container={true}
			direction="column"
			spacing={1}
		>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					margin: '20px',
					color: '#000000',
					fontWeight: 'bold',
					fontSize: '25px',
				}}
			>
				{'Work in progress.'}
			</div>
			{notificationsList.map((notification: any) => {
				return (
					<Grid
						item
						key={`not-${notification.id}`}
						className={classes.notificationItem}
					>
						<div className={classes.notificationName}>
							{notification.name}
						</div>
						<Switch
							className={classes.switchBtn}
							checked={notification.checked}
							onChange={handleChange(notification)}
							value={notification.checked}
							inputProps={{ 'aria-label': 'secondary checkbox' }}
						/>
					</Grid>
				)
			})}
		</Grid>
	)
}
export default memo(Notifications)
